import styled from "styled-components";

import { CircleButton } from "../../common/CircleButton";
import { IconButton } from "../../common/IconButton";

export const ButtonGroup = styled.div`
    display: flex;
    flex-direction: row;
    gap: 0.25rem;
    margin-inline: 0.5rem;
    margin-left: 2rem;

    @media (max-width: 768px) {
        margin-left: 0.5rem;
        margin-inline: 0.25rem;
    }

    @media (max-width: 380px) {
        margin-left: 0;
        margin-inline: 0;
        gap: 0.125rem;
    }
`;

export const HeaderButton = styled(IconButton)<{ selected?: boolean }>`
    padding: 0.5rem;
    box-sizing: border-box;
    border-bottom-width: 0.125rem;
    border-bottom-style: solid;
    border-bottom-color: ${props =>
        props.selected
            ? "var(--formant-color-highlights-blue)"
            : "transparent"};

    &:hover {
        > svg {
            fill: var(--formant-color-primary-white);
        }
    }

    @media (max-width: 768px) {
        padding: 0.25rem;
    }
`;

export const GrayHeaderButton = styled(CircleButton)`
    box-sizing: border-box;
    background-color: var(--formant-color-primary-steel02);

    &:hover {
        > svg {
            fill: var(--formant-color-primary-white);
        }
    }
`;

export const Badge = styled.div<{
    type: "critical" | "error" | "warning" | "info" | "intervention";
}>`
    position: absolute;
    left: calc(100% - 1.5rem);
    top: -0.125rem;
    color: var(--formant-color-primary-black);
    border-radius: 1.25rem;
    font-size: 0.625rem;
    padding: 0.25rem;

    background-color: ${props =>
        ({
            info: "var(--formant-color-data-royal-blue)",
            warning: "var(--formant-color-data-purple)",
            error: "var(--formant-color-data-orange)",
            critical: "var(--formant-color-data-red)",
            intervention: "var(--formant-color-data-green)",
        })[props.type]};

    @media (max-width: 768px) {
        left: calc(100% - 1rem);
        font-size: 0.5rem;
        padding: 0.125rem;
    }
`;

export const Spacer = styled.div`
    flex-grow: 1;
`;
